export const ADD_PRODUCT='ADD_PRODUCT'
export const ADD_PRODUCT_SUCCESS= 'ADD_PRODUCT_SUCCESS'
export const ADD_PRODUCT_ERROR= 'ADD_PRODUCT_ERROR'

export const DELETE_PRODUCT='DELETE_PRODUCT'
export const DELETE_PRODUCT_SUCCESS= 'DELETE_PRODUCT_SUCCESS'
export const DELETE_PRODUCT_ERROR= 'DELETE_PRODUCT_ERROR'

export const GET_PRODUCT= 'GET_PRODUCT'
export const GET_PRODUCT_SUCCESS= 'GET_PRODUCT_SUCCESS'
export const GET_PRODUCT_ERROR= 'GET_PRODUCT_ERROR'

export const GET_PRODUCTS='GET_PRODUCTS'
export const GET_PRODUCTS_SUCCESS= 'GET_PRODUCTS_SUCCESS'
export const GET_PRODUCTS_ERROR='GET_PRODUCTS_ERROR'

export const REORDER_PRODUCTS='REORDER_PRODUCTS'
export const REORDER_PRODUCTS_SUCCESS= 'REORDER_PRODUCTS_SUCCESS'
export const REORDER_PRODUCTS_ERROR='REORDER_PRODUCTS_ERROR'

export const TRANSFER_PRODUCT='TRANSFER_PRODUCT'
export const TRANSFER_PRODUCT_SUCCESS= 'TRANSFER_PRODUCT_SUCCESS'
export const TRANSFER_PRODUCT_ERROR= 'TRANSFER_PRODUCT_ERROR'

export const UNDELETE_PRODUCT='UNDELETE_PRODUCT'
export const UNDELETE_PRODUCT_SUCCESS= 'UNDELETE_PRODUCT_SUCCESS'
export const UNDELETE_PRODUCT_ERROR='DELETE_PRODUCT_ERROR'

export const UPDATE_PRODUCT='UPDATE_PRODUCT'
export const UPDATE_PRODUCT_SUCCESS= 'UPDATE_PRODUCT_SUCCESS'
export const UPDATE_PRODUCT_ERROR= 'UPDATE_PRODUCT_ERROR'

export const UPDATE_PRODUCT_LISTS='UPDATE_PRODUCT_LISTS'
export const UPDATE_PRODUCT_LISTS_SUCCESS= 'UPDATE_PRODUCT_LISTS_SUCCESS'
export const UPDATE_PRODUCT_LISTS_ERROR= 'UPDATE_PRODUCT_LISTS_ERROR'



export const AddProduct= (data) => ({
    type: ADD_PRODUCT,
    payload: data
})

export const DeleteProduct= (data) => ({
    type: DELETE_PRODUCT,
    payload: data
})

export const GetProduct= (data) => ({
    type: GET_PRODUCT,
    payload: data
})

export const GetProducts= (data) => ({
    type: GET_PRODUCTS,
    payload: data
})

export const ReOrderProducts= (data) => ({
    type: REORDER_PRODUCTS,
    payload: data
})

export const TransferProduct= (data) => ({
    type: TRANSFER_PRODUCT,
    payload: data
})

export const UnDeleteProduct= (data) => ({
    type: UNDELETE_PRODUCT,
    payload: data
})

export const UpdateProduct= (data) => ({
    type: UPDATE_PRODUCT,
    payload: data
})
export const UpdateProductLists= (data) => ({
    type: UPDATE_PRODUCT_LISTS,
    payload: data
})
